import React, { useEffect, useState } from "react";
import ApplyForm from "@/components/ApplyForm";
import api from "@/lib/api";
import { becomeLegendDefaults } from "@/pages/navPageDefaults";
import { useSiteContent } from "@/lib/siteContent";

const ID_TYPES = [
  "Victorian Proof of Age Card",
  "Australian Driver Licence or Learner Permit",
  "Passport",
  "Foreign Driver Licence",
  "Keypass Card",
];

export default function BecomeLegend() {
  const content = useSiteContent();
  const [venues, setVenues] = useState([]);

  useEffect(() => {
    api.get("/venues").then((r) => setVenues(r.data || [])).catch(() => {});
  }, []);

  if (!content) return <div className="min-h-[60vh]" />;
  const c = { ...becomeLegendDefaults, ...(content["become-legend"] || {}) };

  const venueOptions = [...venues.map((v) => v.name).filter(Boolean), "Undecided"];

  const successResolver = (extra) =>
    extra.id_verification === "Upload my ID now"
      ? { title: "Thank You", text: "We will be in touch soon." }
      : { title: "Thank You", text: "See you at your first game. Don't forget your ID." };

  return (
    <ApplyForm
      type="become_legend"
      testId="become-legend-page"
      title={c.title}
      subtitle={c.subtitle}
      image={c.image}
      blurb={c.blurb}
      successResolver={successResolver}
      extraFields={[
        { key: "home_venue", label: "Preferred Venue", type: "select", options: venueOptions },
        { key: "birthdate", label: "Date of Birth", type: "date", required: true },
        { key: "id_type", label: "ID Type", type: "select", options: ID_TYPES, required: true },
        { key: "id_verification", label: "ID Verification", type: "radio", required: true, options: ["Upload my ID now", "Bring my ID to my first game"] },
        { key: "id_document", label: "Upload a photo of your ID", type: "image", endpoint: "/upload-id", showIf: { key: "id_verification", value: "Upload my ID now" } },
      ]}
      messageLabel="Tell us a bit about your poker experience"
    />
  );
}
